import React from "react";
import Nav from "../components/sections/Nav";
import Footer from "../components/sections/Footer";
import About from "../components/sections/About";
import SectionDivider from "../components/SectionDivider";
import RevealOnScroll from "../components/RevealOnScroll";
import Seo from "../components/Seo";

const Hero = () => (
    <section
        data-testid="about-page-hero"
        className="relative pt-44 pb-28 lg:pt-52 lg:pb-32"
        style={{ background: "#EEF2ED" }}
    >
        <div className="mx-auto max-w-[960px] px-6 lg:px-12 text-center" data-reveal>
            <span className="editorial-eyebrow">Meet Austine</span>
            <h1 className="mt-6 font-serif text-5xl sm:text-6xl lg:text-[68px] leading-[1.04] text-charcoal text-balance">
                A different kind of therapy —{" "}
                <em className="italic text-gold">for people who are ready to go deeper.</em>
            </h1>
            <div className="mx-auto mt-8" style={{ height: 2, width: 64, background: "#8A9E85" }} />
        </div>
    </section>
);

export default function AboutPage() {
    return (
        <main className="text-charcoal" style={{ background: "#F2EDE6" }} data-testid="about-page">
            <Seo
                title="Meet Austine | Licensed Professional Counselor | Alchemy Practice"
                description="Austine is a Licensed Professional Counselor offering virtual EMDR therapy in Wisconsin and Colorado. Specializing in anxiety, trauma, and self-doubt for high-achieving adults."
            />
            <Nav />
            <RevealOnScroll>
                <Hero />
                <SectionDivider color="gold" bg="#EEF2ED" />
                <About />
                <Footer />
            </RevealOnScroll>
        </main>
    );
}
